import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = '/api';

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext);

const defaultSettings = {
  app_name: "Noleggio Veloce",
  app_tagline: "Gestione Noleggi Senza Freni",
  app_icon_url: "",
  login_image_url: "https://images.unsplash.com/photo-1625869740698-983464d352ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxmaWF0JTIwNTAwJTIwdmludGFnZSUyMGl0YWx5JTIwc3RyZWV0fGVufDB8fHx8MTc3MzQ2OTY0Nnww&ixlib=rb-4.1.0&q=85",
  login_quote: "Gestisci la tua flotta con stile e velocità.",
  primary_color: "#DC2626"
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then((res) => {
        const merged = { ...defaultSettings, ...res.data };
        setSettings(merged);
        applyTheme(merged);
        setLoaded(true);
      })
      .catch(() => {
        setLoaded(true);
      });
  }, []);

  const applyTheme = (s) => {
    const gold = s.color_theme === "gold";
    const accent = gold ? "#D9A441" : (s.primary_color || '#DC2626');
    document.documentElement.style.setProperty('--accent', accent);
    document.documentElement.classList.toggle('theme-gold', gold);
  };

  const updateSettings = (newSettings) => {
    setSettings((prev) => {
      const updated = { ...prev, ...newSettings };
      applyTheme(updated);
      return updated;
    });
  };

  const exposed = settings.color_theme === "gold"
    ? { ...settings, primary_color: "#D9A441", original_primary_color: settings.primary_color }
    : settings;

  return (
    <SettingsContext.Provider value={{ settings: exposed, updateSettings, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
};
